// extracted by mini-css-extract-plugin
export var promotionLink = "_vp-0";